import { getRelativeTime } from '@nest/utils-shared';
import { formatDate } from 'date-fns';
import { useMemo } from 'react';
export const RelativeDateTime = ({ date, displayType = 'Relative' }) => {
    const relativeTime = useMemo(() => (date ? getRelativeTime(date, displayType) : null), [date, displayType]);
    return relativeTime;
};
export const DateTimeFormat = ({ date, format = 'dd.MM.yyyy HH:mm' }) => {
    const formattedDate = useMemo(() => (date ? formatDate(date, format) : null), [date, format]);
    return formattedDate;
};
//# sourceMappingURL=date-time.js.map